import { useQuery } from '@tanstack/react-query'
import OrganizationService from '../../services/Organization.service'
import { OrganizationResponse } from '../../models/Organization.model'

type OrganizationsOptions = {
  userId?: string
  size?: number
  enabled: boolean
}

export const useMyOrganizations = ({ userId, size = 20, enabled }: OrganizationsOptions) => {
  return useQuery<OrganizationResponse>({
    queryKey: ['my-organizations', userId, size],
    queryFn: () => OrganizationService.listMy(0, size),
    enabled,
  })
}

// export const useMyOrganizations = ({ userId, ...payload }: OrganizationsOptions) => {
//   return useInfiniteQuery<OrganizationResponse>({
//     queryKey: ['my-organizations', userId, payload],
//     queryFn: ({ pageParam }) => OrganizationService.listMy(pageParam as number, payload.size),
//     initialPageParam: 0,
//     getNextPageParam: (lastPage, _2, lastPageParam) => {
//       if (lastPage.organizations.length === 0) {
//         return undefined
//       }
//       return Number(lastPageParam) + 1
//     },
//     enabled: payload.enabled,
//   })
// }
